var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDecline(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#676879",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.34331 4.34331C5.84371 2.84291 7.87868 2 10.0006 2C12.1224 2 14.1574 2.84291 15.6578 4.34331C17.1582 5.84371 18.0011 7.87868 18.0011 10.0006C18.0011 12.1224 17.1582 14.1574 15.6578 15.6578C14.1574 17.1582 12.1224 18.0011 10.0006 18.0011C7.87868 18.0011 5.84371 17.1582 4.34331 15.6578C2.84291 14.1574 2 12.1224 2 10.0006C2 7.87868 2.84291 5.84371 4.34331 4.34331ZM10.0006 3.5C8.2765 3.5 6.62306 4.18488 5.40397 5.40397C4.18488 6.62306 3.5 8.2765 3.5 10.0006C3.5 11.7246 4.18488 13.3781 5.40397 14.5971C6.62306 15.8162 8.2765 16.5011 10.0006 16.5011C11.7246 16.5011 13.3781 15.8162 14.5971 14.5971C15.8162 13.3781 16.5011 11.7246 16.5011 10.0006C16.5011 8.2765 15.8162 6.62306 14.5971 5.40397C13.3781 4.18488 11.7246 3.5 10.0006 3.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.23535 7.17463C7.94245 6.88173 7.46758 6.88173 7.17469 7.17463C6.88179 7.46752 6.88179 7.94239 7.17469 8.23529L8.93955 10.0002L7.17511 11.7646C6.88221 12.0575 6.88221 12.5324 7.17511 12.8253C7.468 13.1182 7.94287 13.1182 8.23577 12.8253L10.0002 11.0608L11.7647 12.8253C12.0576 13.1182 12.5324 13.1182 12.8253 12.8253C13.1182 12.5324 13.1182 12.0575 12.8253 11.7646L11.0609 10.0002L12.8257 8.23529C13.1186 7.94239 13.1186 7.46752 12.8257 7.17463C12.5328 6.88173 12.058 6.88173 11.7651 7.17463L10.0002 8.93949L8.23535 7.17463Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecline);
export default __webpack_public_path__ + "static/media/decline.f6886251.svg";
export { ForwardRef as ReactComponent };